import { render, staticRenderFns } from "./QuestionAndAnswer.vue?vue&type=template&id=31ba3a5a&"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports